import React, { useEffect, useState  } from "react";
import { useNavigate } from 'react-router-dom';

import { auth, signInWithGoogle, 
    getData,addData } 
    from "../../configs/firebase";
import { onAuthStateChanged } from "firebase/auth";


// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faEye , faEyeSlash} from '@fortawesome/free-solid-svg-icons';

import { IMAGES } from "../../constants/index"
import { TITLE, CAMPAIGN_DATE } from "../../constants/constants"

import './LoginPage.css';

function LoginPage(){
    let navigate = useNavigate();

    const [user, setUser] = useState(null);
    const [opacity, setOpacity] = useState(1);


    // 🔹 로그인 상태 감지
    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
            setUser(currentUser);
        });
        return () => unsubscribe();
    }, []);

    useEffect(() => {
        if(user){
            getUserData(user.uid);
        } 
    },[user])


    const getUserData = async (userId) => {
        let data;
        try{
            const result = await getData(userId);
            if(result?.length==0) {
                data = {
                    "userId": userId,
                    "event": {
                        "prologue":false,
                        "epilogue":false
                    },
                    "checkList": []
                }
                await addData(data)
            } else {
                data = result[0]
            }
        } catch (e) {
            console.error("데이터 조회 및 생성 오류",e)
        } finally {
            setOpacity(0); // 🔥 페이드 아웃 시작
            setTimeout(() => {
                if(!data.event.prologue) handleNavigation('/prologue');
                else handleNavigation('/byFaith');
            }, 2000);
        }
    }

    const handleNavigation = (addrss) => {
        navigate(addrss);
    }

    
    return (
        <div
            className="loginWrap"
            style={{
                backgroundImage: `url(${IMAGES.BACKGROUMND})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
            }}
        >
            <div className={`titleContainer`} style={{ opacity, transition: "opacity 1s ease-in-out" }}>
                <p className="title">{TITLE}</p>
            </div>
            <div className={`loginContainer`} style={{ opacity, transition: "opacity 1s ease-in-out" }}>
                <div className="logiConstentsBox">
                    <button className="google-btn" onClick={signInWithGoogle}>
                        <img
                        src="https://developers.google.com/identity/images/g-logo.png"
                        alt="Google Logo"
                        className="google-icon"
                        />
                        Google 계정으로 로그인
                    </button>
                </div>
            </div>
        </div>
    );
  }
  export default LoginPage;